import { useState, useEffect } from 'react';

/**
 * Hook personalizado para manejar el estado local de la fecha "Válido Hasta"
 * Ahora lee directamente del campo valido_hasta en lugar de observaciones
 */
export const useLocalDate = (validoHasta?: string) => {
  const [localSelectedDate, setLocalSelectedDate] = useState<string>(() => {
    // Usar directamente el campo valido_hasta si existe
    return validoHasta ?? '';
  });

  // Actualizar el estado local cuando cambie validoHasta
  useEffect(() => {
    setLocalSelectedDate(validoHasta ?? '');
  }, [validoHasta]);

  return { localSelectedDate, setLocalSelectedDate };
};

